const lazyLooxCarouselSelector = '[data-iicase-lazy-loox-carousel]';

function finishLazyLooxCarouselLoading(container) {
  container.dataset.iicaseLooxCarouselState = 'ready';
  container.querySelector('[data-iicase-lazy-loox-carousel-placeholder]')?.remove();
}

function watchLazyLooxCarouselFrame(container) {
  let timeoutId;

  const checkFrame = () => {
    const widget = container.querySelector('.loox-v2-carousel-container');
    const frame = widget?.querySelector('iframe[src*="loox.io/widget/"][src*="/v2/carousel"]');
    if (!(widget instanceof HTMLElement) || !(frame instanceof HTMLIFrameElement)) return false;

    const renderedHeight = Math.max(
      Number.parseFloat(widget.style.height) || 0,
      widget.getBoundingClientRect().height
    );
    if (renderedHeight <= 0) return false;

    window.clearTimeout(timeoutId);
    observer.disconnect();
    finishLazyLooxCarouselLoading(container);
    return true;
  };

  const observer = new MutationObserver(checkFrame);
  observer.observe(container, {
    attributes: true,
    attributeFilter: ['height', 'style'],
    childList: true,
    subtree: true,
  });

  timeoutId = window.setTimeout(() => {
    initializeLooxCarousel(container);
  }, 6000);

  checkFrame();
}

function initializeLooxCarousel(container, attemptsRemaining = 40) {
  if (!(container instanceof HTMLElement) || container.dataset.iicaseLooxCarouselState !== 'loading') return;

  if (typeof window.LOOX?.initLooxCarouselV2 === 'function') {
    window.LOOX.initLooxCarouselV2();
    return;
  }

  if (attemptsRemaining <= 0) return;
  window.setTimeout(() => initializeLooxCarousel(container, attemptsRemaining - 1), 125);
}

function hydrateLazyLooxCarousel(container) {
  if (!(container instanceof HTMLElement) || container.dataset.iicaseLooxCarouselState) return;

  const template = container.querySelector('template[data-iicase-lazy-loox-carousel-content]');
  if (!(template instanceof HTMLTemplateElement)) return;

  container.dataset.iicaseLooxCarouselState = 'loading';
  watchLazyLooxCarouselFrame(container);
  template.replaceWith(template.content.cloneNode(true));
  initializeLooxCarousel(container);
}

function initializeLazyLooxCarousels() {
  const containers = Array.from(document.querySelectorAll(lazyLooxCarouselSelector));
  if (containers.length === 0) return;

  if (!('IntersectionObserver' in window)) {
    containers.forEach(hydrateLazyLooxCarousel);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        hydrateLazyLooxCarousel(entry.target);
      });
    },
    { rootMargin: '600px 0px', threshold: 0 }
  );

  containers.forEach((container) => observer.observe(container));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeLazyLooxCarousels, { once: true });
} else {
  initializeLazyLooxCarousels();
}
